import React from 'react';
import Grid from '@mui/material/Grid';
import {Button, Typography} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import BackupContentButton from "./BackupContentButton";

export default function ShiftCalendarToolbar({toolbar}) {
    const goToPreviousDay = () => toolbar.onNavigate('PREV');
    const goToNextDay = () => toolbar.onNavigate('NEXT');
    const goToToday = () => toolbar.onNavigate('TODAY');

  return (
    <Grid container alignItems="center" justifyContent="space-between" sx={{padding: '0.5rem'}}>
        <Grid item display="flex" gap="0.1rem">
            <Button onClick={goToToday} variant="outlined" size="small" sx={{paddingTop: '0.3rem'}}>Today</Button>
            <Button onClick={goToPreviousDay} variant="outlined" sx={{padding: '0.2rem', minWidth: '1rem'}}>
                <ArrowBackIosNewIcon fontSize="inherit"/>
            </Button>
            <Button onClick={goToNextDay} variant="outlined" sx={{padding: '0.2rem', minWidth: '1rem'}}>
                <ArrowForwardIosIcon fontSize="inherit"/>
            </Button>
        </Grid>

        <Grid item>
            <Typography variant="subtitle1">{toolbar.label}</Typography>
        </Grid>

        <Grid item>
            <BackupContentButton />
        </Grid>
    </Grid>
  );
}